import { css } from '@emotion/react'
import { format } from 'date-fns'
import { graphql, useStaticQuery } from 'gatsby'
import { ComponentPropsWithoutRef, useState } from 'react'

import { Calendar } from '@/features/calendar'

import {
  AlumnaeEventFilter,
  AlumnaeEventFilterData,
  filtersArray,
} from './AlumnaeEventFilter'

export const AlumnaeEvents = ({
  ...props
}: ComponentPropsWithoutRef<'section'>): JSX.Element => {
  const { allDatoCmsAlumnaeEvent } =
    useStaticQuery<Queries.AlumnaeEventsQuery>(graphql`
      query AlumnaeEvents {
        allDatoCmsAlumnaeEvent(
          sort: { dateAndTime: ASC }
          filter: { isUpcoming: { eq: true } }
        ) {
          nodes {
            isUpcoming
            ...AlumnaeEvent
          }
        }
      }
    `)
  const [activeFilter, setActiveFilter] =
    useState<AlumnaeEventFilterData>()

  const filteredEvents = allDatoCmsAlumnaeEvent.nodes.reduce(
    (acc, event) => {
      if (
        activeFilter === undefined ||
        event.eventType === activeFilter
      ) {
        const date = new Date(event?.dateAndTime || '')
        const month = format(date, 'MMMM')
        const year = format(date, 'yyyy')
        const matchingMonthYear = acc.find(
          val => val.month === month && val.year === year
        )
        if (matchingMonthYear) {
          matchingMonthYear.events.push(event)
        } else {
          acc.push({ month: month, year: year, events: [event] })
        }
      }
      return acc
    },
    [] as {
      month: string
      year: string
      events: Queries.AlumnaeEventFragment[]
    }[]
  )
  const styles = {
    section: css`
      padding: var(--row-72) var(--margin);
      background: #fff;
    `,
    error: css`
      min-height: 6em;
      display: grid;
      align-items: center;
    `,
  }
  return (
    <section
      css={styles.section}
      {...props}
    >
      <AlumnaeEventFilter
        activeFilter={activeFilter}
        setActiveFilter={setActiveFilter}
      />
      <Calendar
        eventsByMonth={filteredEvents}
        errorMessage={
          <div css={styles.error}>{`There are currently no upcoming ${
            activeFilter
              ? filtersArray.find(filter => filter === activeFilter)
              : 'Alumnae Events'
          }. Please check back soon.`}</div>
        }
      />
    </section>
  )
}
